/**
 * Donde NO va el chat de soporte (Tawk.to).
 *
 * Las tres superficies del partner —el portal, su login y la landing del
 * programa— ya llevan su propio card de ayuda, con el correo y el telefono de
 * Workloop. El widget encima de eso no solo sobra: se sienta anclado abajo a la
 * derecha y tapaba el "Llamanos" en movil (medido: el widget ocupa y=694-754 y
 * el enlace caia en 699-743).
 *
 * Y no es el mismo soporte. Ese chat atiende dudas del PRODUCTO — negocios que
 * evaluan o usan Workloop. Un partner que pregunta por su codigo o por cuando
 * cobra cae en una cola que no sabe de partners.
 *
 * `/r/:code` queda FUERA de esta lista a proposito: esa la abre un negocio
 * potencial que escaneo un flyer, no el partner. Ahi el chat es exactamente lo
 * que quieres.
 */
const PARTNER_PATHS = [/^\/(es\/)?socio(\/|$)/, /^\/(es\/)?partners(\/|$)/, /^\/(es\/)?activar(\/|$)/];

/**
 * Las dos paginas del cliente, y por una razon distinta a la del partner.
 *
 * Quien abre /e/:token o /q/:slug no es un cliente potencial de Workloop: es el
 * cliente del fontanero, mirando el presupuesto que va a firmar. Este chat
 * atiende dudas del PRODUCTO, asi que una pregunta sobre su calentador cae en
 * una cola que no sabe quien es — y la persona acaba hablando con el proveedor
 * de su fontanero en vez de con su fontanero.
 *
 * Ademas el widget reescribe el <title> a "1 new message" encima de un
 * documento firmable.
 */
const CUSTOMER_DOCUMENT_PATHS = [/^\/(e|q)\//];

export function isChatHiddenPath(pathname: string): boolean {
  return [...PARTNER_PATHS, ...CUSTOMER_DOCUMENT_PATHS].some((re) => re.test(pathname));
}

interface TawkApi {
  hideWidget?: () => void;
  showWidget?: () => void;
  onLoad?: () => void;
}

function tawk(): TawkApi | undefined {
  return (window as unknown as { Tawk_API?: TawkApi }).Tawk_API;
}

/**
 * Se llama en cada cambio de ruta. Cubre la navegacion dentro del SPA: quien
 * entra directo a /socio nunca carga el script (lo decide index.html), pero
 * quien llega desde la home ya lo tiene montado y hay que esconderlo.
 *
 * hideWidget() revienta si se llama antes de que Tawk termine de cargar, asi
 * que si aun no esta listo la orden se deja en onLoad.
 */
export function syncSupportChat(pathname: string): void {
  const api = tawk();
  if (!api) return;
  const hide = isChatHiddenPath(pathname);
  const apply = () => {
    try {
      if (hide) api.hideWidget?.();
      else api.showWidget?.();
    } catch {
      // El widget es de terceros y su API no es estable. Que no aparezca —o que
      // no desaparezca— nunca puede tumbar la pagina.
    }
  };
  if (typeof api.hideWidget === 'function') apply();
  else api.onLoad = apply;
}
